<style src="@/assets/styles/components/modules/checkout/thankyou.styl" lang="stylus" scoped></style>
<template src="@/components/collections/templates/ThankyouTemplate.html"></template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import ThankyouMixin from "@/mixins/thank-you-mixin"
export default {
  mixins: [ThankyouMixin],
  data() {
    return {
      goto_app: false
    }
  },
  mounted() {
    this.editMode = this.$route.query.mode == "edit";
  },
  computed: {
    showReferralSection() {
      return this.campaignDetails && this.campaignDetails.referral_system == "referral_candy" && this.campaignDetails.show_post_widget;
    },
    ...mapGetters(["campaignDetails"])
  },
  methods: {
    close() {
      if (window.parent == window) {
        // window.close();
      }
      window.cbPostMessage("cb.close");
    }
  }
}
</script>
